const API_CONFIG = {
    // BASE_URL: 'http://localhost:3000/api'
    BASE_URL: 'https://qharlzkvds.uswest02.qoddiapp.com/api'
    // BASE_URL: 'http://192.168.88.5:3000/api'
}

export default API_CONFIG;